import { render, staticRenderFns } from "./ProjectPropertyKeyEditPage.vue?vue&type=template&id=2cd56b11&"
import script from "./ProjectPropertyKeyEditPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectPropertyKeyEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports